var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 15H120V105.094C120 126.945 102.183 144.594 80.5 144.594C58.817 144.594 41 126.777 41 105.094V15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.143 27.6064H43.8575V105.094C43.8575 125.264 60.3298 141.736 80.5 141.736C100.67 141.736 116.974 125.264 116.974 105.094V27.6064H117.143Z",
    fill: "#023F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.317 73.4936L101.679 76.5191H107.898L111.091 73.4936H98.317Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2957 37.3553L53.2702 53.9957H59.3213L56.2957 37.3553Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.679 69.2915H98.317V71.8128H111.091V69.2915H107.898H101.679Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6829 73.4936H49.9085L53.1021 76.5191H59.3212L62.6829 73.4936Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.898 78.2H101.679V84.0829H107.898V78.2Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3213 78.0319H53.1021V84.083H59.3213V78.0319Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.679 89.9659H99.6617V85.7638H97.6447V86.9404H95.6277V85.7638H65.2043V86.9404H63.1872V85.7638H61.1702V89.9659H59.1532V85.7638H53.1021V106.438C53.1021 116.187 58.3128 125.264 66.8851 130.138C61.3383 125.936 57.9766 119.213 57.9766 112.321C57.9766 101.06 66.3809 91.4787 77.4745 90.134H83.1894C94.283 91.6468 102.687 101.06 102.687 112.321C102.687 119.213 99.4936 125.936 93.9468 130.138C102.351 125.264 107.562 116.187 107.562 106.438V85.7638H101.343V89.9659H101.679Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.851 69.2915H49.9085V71.8128H62.851V69.2915Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3213 55.6766H53.1021V67.6106H59.3213V55.6766Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.898 55.6766H101.679V67.6106H107.898V55.6766Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.704 37.3553L101.679 53.9957H107.73L104.704 37.3553Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6171 97.866H86.383L87.3915 117.868H73.6086L74.6171 97.866Z",
    fill: "#00B7CE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5 108.96L83.3574 117.868H92.7702L85.2064 123.247L88.0638 132.155L80.5 126.609L72.9362 132.155L75.7936 123.247L68.3979 117.868H77.6425L80.5 108.96Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.417 94V95.1766H87.8957V96.8574H73.1042V95.1766H70.5829V94H90.417Z",
    fill: "#00B7CE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.617 91.3106L67.2212 86.9404H93.7787L86.3829 91.3106V92.8234H74.617V91.3106Z",
    fill: "#00B7CE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1724 68.4511C89.2405 68.7872 95.7958 75.5107 95.7958 83.7468H65.2043C65.2043 75.5107 71.7596 68.7872 79.8277 68.4511L80.5 63.7447L81.1724 68.4511Z",
    fill: "#00B7CE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3723 87.949H63.3553V89.966H65.3723V87.949Z",
    fill: "#023F88"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8127 87.949H95.7957V89.966H97.8127V87.949Z",
    fill: "#023F88"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5405 56.8532L61.0022 53.1553L66.8851 54.8362L68.566 52.8192L70.2468 56.0128L76.1298 58.0298L71.4234 58.534L73.2724 62.2319L68.2298 58.8702L63.8596 59.2064L65.5405 56.8532Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3063 51.4744L82.3489 52.8191L83.6936 51.3063L85.0383 53.8276L89.7446 55.5085L86.0468 55.8446L87.3914 59.0383L83.3574 56.0127L79.8276 56.3489L81.1723 54.5L77.3063 51.4744Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4 47.7766L92.266 48.9532L93.2745 47.2724L94.4511 49.6256L98.149 50.8022L95.2915 51.1383L96.3 53.4915L93.2745 51.3064L90.417 51.8107L91.2575 50.1298L88.4 47.7766Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1064 42.2298L96.3 42.9022L96.9723 41.7256L98.1489 43.4064L101.174 44.2469L98.8213 44.583L99.8298 46.432L97.1404 44.9192L94.7872 45.2554L95.4596 43.9107L93.1064 42.2298Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9213 37.0192L93.2745 37.3554L93.7787 36.683L94.6192 37.6915L96.8043 38.1958L95.1234 38.532L95.9638 39.8766L93.9468 38.8681L92.0979 39.3724L92.7702 38.1958L90.9213 37.0192Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4085 23.4042H85.0383L84.534 24.4127H81.5085L85.5426 17.3532H89.0723L93.1064 24.2447H90.0809L89.4085 23.4042ZM85.7106 22.0596H88.7362L87.2234 19.2021L85.7106 22.0596ZM51.9255 23.4042H47.3872L46.883 24.2447H43.8575L47.8915 17.1851H51.4213L55.4553 24.2447H52.4298L51.9255 23.4042ZM48.0596 22.0596H51.0851L49.5723 19.2021L48.0596 22.0596ZM113.445 23.4042H108.906L108.402 24.4127H105.377L109.411 17.3532H112.94L116.974 24.4127H113.949L113.445 23.4042ZM109.747 22.0596H112.94L111.428 19.2021L109.747 22.0596ZM56.9681 17.1851H59.9936L64.0277 21.051V17.1851H67.0532V24.2447H64.0277L59.9936 20.3787V24.2447H56.9681V17.1851ZM69.7426 17.1851H72.9362V19.8745L76.8021 17.1851H80.8362L76.9702 19.8745L81.0043 24.2447H77.1383L74.617 21.3872L73.1043 22.3957V24.0766H69.9106V17.1851H69.7426ZM102.855 20.883C103.864 21.2191 104.536 22.0596 104.704 23.0681L104.872 24.2447H101.511L101.343 23.0681C101.174 22.0596 101.006 21.3872 99.6617 21.3872H97.9809V24.2447H94.6192V17.1851H101.006C101.679 17.1851 102.687 17.1851 103.36 17.6893C103.864 18.0255 104.2 18.3617 104.2 19.2021C104.368 20.0425 103.528 20.7149 102.855 20.883ZM97.9809 20.0425H99.3255C99.6617 20.0425 100.334 20.0425 100.67 19.7064C100.838 19.5383 100.838 19.3702 100.838 19.2021C100.838 19.034 100.67 18.8659 100.502 18.6979C100.334 18.5298 99.8298 18.5298 99.3255 18.5298H97.8128V20.0425H97.9809Z",
    fill: "#023F88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbb);
export default __webpack_public_path__ + "static/media/abb.ac66082f6a8b0c79e0aed2223b87ab72.svg";
export { ForwardRef as ReactComponent };